import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d9b2940"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statistic-table" }
const _hoisted_2 = { class: "statistic-table__header" }
const _hoisted_3 = { class: "statistic-table__title" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Статистика ")
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Назад ")
const _hoisted_7 = { class: "statistic-table__content" }
const _hoisted_8 = { class: "statistic-table__column-header" }
const _hoisted_9 = {
  key: 0,
  class: "statistic-table__amount"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ФИО врача:", -1))
const _hoisted_11 = {
  key: 1,
  class: "statistic-table__amount"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Название:", -1))
const _hoisted_13 = {
  key: 2,
  class: "statistic-table__states"
}
const _hoisted_14 = { class: "statistic-table__amount" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Отобр.:", -1))
const _hoisted_16 = { class: "statistic-table__amount" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Мин.:", -1))
const _hoisted_18 = { class: "statistic-table__amount" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Макс.:", -1))
const _hoisted_20 = {
  key: 3,
  class: "statistic-table__amount"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Архив:", -1))

import { useRoute } from 'vue-router'
import { statisticApi } from '@/shared/api'
import {
  OrganizationPartner,
  StatisticTableType,
  OrganizationStatus,
  OrganizationSubscription,
} from '@/shared/types'
import { showErrorMessage } from '@/shared/utils'
import { computed, onMounted, ref, watch } from 'vue'
import ru from 'element-plus/es/locale/lang/ru'
import router from '@/apps/router'
import { tariffsApi } from '@/shared/api/admin/tariffs.api'
import { useUser } from '@/shared/composables'
import { ORGANIZATION_STATUSES } from '@/shared/constants/organization'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { user } = useUser()
const route = useRoute()
const loading = ref(false)
const organizationId = computed(() => route.query.organizationId as string)

const tablePropsData = ref([])
const summary = ref()
const dateFilters = ref([])
const minAmount = ref(null)
const maxAmount = ref(null)
const totalCountOfElements = ref(0)
const organizationName = ref(null)
const currentOrganizationName = ref(null)
const userName = ref(null)
const currentPage = ref(1)
const countOnPage = ref(15)
const partner = ref<OrganizationPartner>(null)
const status = ref<OrganizationStatus>(null)
const subscriptionType = ref<OrganizationSubscription>(null)
const tariffTitle = ref(null)
const tariffs = ref([])
const showArchive = ref(false)

const offset = computed(() => countOnPage.value * (currentPage.value - 1))

const formateResponseStatistic = (response: StatisticTableType) => {
  const {
    reports_count,
    brushmaps_count,
    screenings_count,
    periodontologies_count,
    total_report_count,
    timely_appointments_count,
    yearly_timely_appointments_count,
    tariff_stats,
  } = response.statistics

  const responseData = {
    name: response.name,
    countPlaqueIndex: reports_count.total,
    countScreening: screenings_count.total,
    countBrushMap: brushmaps_count.total,
    countPeriodontalMap: periodontologies_count.total,
    timelyCount: timely_appointments_count.total,
    yearlyTimelyCount: yearly_timely_appointments_count.total,
    countTotal: total_report_count,
    id: response.id,
    tariffUsage: '-',
    tariffRemaining: '-',
    tariffLimit: '-',
  }

  if (tariff_stats) {
    responseData.tariffUsage = tariff_stats.usage
      ? tariff_stats.usage.toString()
      : '-'
    responseData.tariffRemaining = tariff_stats.overdraft
      ? tariff_stats.overdraft.toString()
      : '-'
    responseData.tariffLimit = tariff_stats.limit
      ? tariff_stats.limit.toString()
      : '-'
  }

  return responseData
}

const getOrganizations = async (): Promise<void> => {
  if (user.value.role !== 'admin') {
    return
  }

  currentOrganizationName.value = null
  loading.value = true
  const dateFrom = Array.isArray(dateFilters.value)
    ? dateFilters.value[0]
    : undefined
  const dateTo = Array.isArray(dateFilters.value)
    ? dateFilters.value[1]
    : undefined

  const [error, response] =
    await statisticApi.getOrganizationDynamicReportCreation(
      dateFrom,
      dateTo,
      maxAmount.value,
      minAmount.value,
      countOnPage.value,
      offset.value,
      partner.value,
      status.value,
      tariffTitle.value,
      organizationName.value,
      showArchive.value,
      subscriptionType.value
    )

  if (error) {
    showErrorMessage(error)
  } else {
    totalCountOfElements.value = response.data.organization_count
    const formattedResponse = (
      response.data.statistics as StatisticTableType[]
    ).map(formateResponseStatistic)
    tablePropsData.value = formattedResponse
  }

  loading.value = false
}

const getRowClassName = (row: any) => {
  if (row.rowIndex === 0 && currentPage.value === 1 && organizationId.value) {
    return 'white-row-bold'
  }
  return 'white-row'
}

const getTariffs = async (): Promise<void> => {
  if (user.value.role != 'admin') {
    return
  }

  const [error, response] = await tariffsApi.getTariffsList()

  if (error) {
    showErrorMessage(error)
  } else {
    tariffs.value = response.data.tariffs
  }
}

const getUsers = async (): Promise<void> => {
  loading.value = true
  const dateFrom = Array.isArray(dateFilters.value)
    ? dateFilters.value[0]
    : undefined
  const dateTo = Array.isArray(dateFilters.value)
    ? dateFilters.value[1]
    : undefined

  const [error, response] = await statisticApi.getUserDynamicReportCreation(
    organizationId.value,
    dateFrom,
    dateTo,
    maxAmount.value,
    minAmount.value,
    countOnPage.value,
    offset.value,
    userName.value
  )

  if (error) {
    showErrorMessage(error)
  } else {
    totalCountOfElements.value = response.data.user_count
    currentOrganizationName.value = response.data.name
    summary.value = {
      name: 'Всего',
      id: 0,
      countPlaqueIndex: response.data.summary.reports_count,
      countScreening: response.data.summary.screenings_count,
      countBrushMap: response.data.summary.brushmaps_count,
      countPeriodontalMap: response.data.summary.periodontologies_count,
      timelyCount: response.data.summary.timely_appointments_count,
      yearlyTimelyCount: response.data.summary.yearly_timely_appointments_count,
      countTotal: response.data.summary.total_report_count,
    }
    const formattedResponse = (
      response.data.doctor_statistics as StatisticTableType[]
    ).map(formateResponseStatistic)
    tablePropsData.value = formattedResponse
  }

  loading.value = false
}

const routeToOrganizationPage = () => {
  router.push({
    name: 'OrganizationEditionPage',
    params: { organizationId: organizationId.value },
  })
}

const routeToOrganization = async (dataSelectedTableRow: any) => {
  if (!organizationId.value) {
    await router.push({
      query: { organizationId: dataSelectedTableRow.id },
    })
    currentPage.value = 1
    getUsers()
  }
}

const routeToListOrganization = async () => {
  await router.push({ query: null })
  getOrganizations()
  getTariffs()
}

const handleChangeCurrentPage = (page: number): void => {
  currentPage.value = page

  getElements()
}

const getElements = () => {
  if (organizationId.value) {
    getUsers()
  } else {
    getOrganizations()
  }
}

watch(minAmount, () => {
  if (minAmount.value === 0) {
    getElements()
  }
})

watch(organizationId, () => {
  getElements()
})

watch(
  [partner, status, tariffTitle, subscriptionType],
  () => {
    getOrganizations()
  },
  { deep: true }
)

onMounted(() => {
  if (organizationId.value) {
    getUsers()
    return
  }

  getOrganizations()
  getTariffs()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _hoisted_4,
        (_unref(organizationId) && _unref(user).role === 'admin')
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "statistic-table__title__organization",
              onClick: routeToOrganizationPage
            }, _toDisplayString(currentOrganizationName.value), 1))
          : _createCommentVNode("", true),
        (_unref(organizationId) && _unref(user).role !== 'admin')
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(currentOrganizationName.value), 1))
          : _createCommentVNode("", true)
      ]),
      (_unref(organizationId) && _unref(user).role === 'admin')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "additional",
            class: "statistic-table__back",
            onClick: routeToListOrganization
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_config_provider, { locale: _unref(ru) }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            class: _normalizeClass(["table", { table_organizations: !_unref(organizationId) }]),
            onRowClick: routeToOrganization,
            "row-class-name": getRowClassName,
            "cell-class-name": "white-cell",
            "max-height": "790",
            data: tablePropsData.value,
            "default-sort": { prop: 'countTotal', order: 'descending' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, null, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    (_unref(organizationId))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _hoisted_10,
                          _createVNode(_component_el_input, {
                            onChange: getElements,
                            class: "statistic-table__amount--wide-filter",
                            modelValue: userName.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userName).value = $event)),
                            controls: false
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (!_unref(organizationId))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _hoisted_12,
                          _createVNode(_component_el_input, {
                            onChange: getElements,
                            class: "statistic-table__amount--wide-filter",
                            modelValue: organizationName.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((organizationName).value = $event)),
                            controls: false
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (!_unref(organizationId))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_component_el_select, {
                            clearable: "",
                            placeholder: "Партнёр",
                            modelValue: partner.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((partner).value = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                value: "dentalpro",
                                label: "DentalPro"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_el_select, {
                            clearable: "",
                            placeholder: "Тип",
                            modelValue: status.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((status).value = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ORGANIZATION_STATUSES), (statusName, statusKey) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  value: statusKey,
                                  label: statusName
                                }, null, 8, ["value", "label"]))
                              }), 256)),
                              _createVNode(_component_el_option, {
                                value: "no_type",
                                label: "Без типа"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_el_select, {
                            clearable: "",
                            placeholder: "Тариф",
                            modelValue: tariffTitle.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tariffTitle).value = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tariffs.value, (tariff) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  value: tariff.title,
                                  label: tariff.display_title
                                }, null, 8, ["value", "label"]))
                              }), 256)),
                              _createVNode(_component_el_option, {
                                value: "no_tariff",
                                label: "Без тарифа"
                              }),
                              _createVNode(_component_el_option, {
                                value: "custom",
                                label: "Индивидуальный"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_el_select, {
                            clearable: "",
                            placeholder: "Подписка",
                            modelValue: subscriptionType.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((subscriptionType).value = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                value: "monthly",
                                label: "Месячная"
                              }),
                              _createVNode(_component_el_option, {
                                value: "yearly",
                                label: "Годовая"
                              }),
                              _createVNode(_component_el_option, {
                                value: "trimonthly",
                                label: "Трехмесячная"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode(_component_el_input_number, {
                        onChange: getElements,
                        class: "statistic-table__amount--filter",
                        modelValue: countOnPage.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((countOnPage).value = $event)),
                        modelModifiers: { number: true },
                        controls: false,
                        min: 1
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_el_input_number, {
                        onChange: getElements,
                        class: "statistic-table__amount--filter",
                        modelValue: minAmount.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((minAmount).value = $event)),
                        modelModifiers: { number: true },
                        controls: false,
                        min: 0
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_el_input_number, {
                        class: "statistic-table__amount--filter",
                        onChange: getElements,
                        modelValue: maxAmount.value,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((maxAmount).value = $event)),
                        modelModifiers: { number: true },
                        controls: false,
                        min: 0
                      }, null, 8, ["modelValue"])
                    ]),
                    (!_unref(organizationId))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _hoisted_21,
                          _createVNode(_component_el_checkbox, {
                            modelValue: showArchive.value,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showArchive).value = $event)),
                            onChange: getElements
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_date_picker, {
                      class: "statistic-table__date",
                      style: { maxWidth: '300px' },
                      modelValue: dateFilters.value,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dateFilters).value = $event)),
                      "end-placeholder": "Конец",
                      format: "DD.MM.YYYY",
                      "start-placeholder": "Начало",
                      type: "daterange",
                      "value-format": "YYYY-MM-DD",
                      onChange: getElements
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                default: _withCtx(() => [
                  (_unref(organizationId))
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 0,
                        prop: "name",
                        label: "Имя",
                        width: "300"
                      }))
                    : _createCommentVNode("", true),
                  (!_unref(organizationId))
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 1,
                        prop: "name",
                        label: "Название",
                        width: "300"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_table_column, {
                    prop: "countPlaqueIndex",
                    label: "Индекс Налёта",
                    width: "155",
                    "header-align": "center",
                    align: "right",
                    sortable: ""
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "countBrushMap",
                    label: "Карта ёршиков",
                    width: "155",
                    "header-align": "center",
                    align: "right",
                    sortable: ""
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "countScreening",
                    label: "Скрининг",
                    width: "120",
                    "header-align": "center",
                    align: "right",
                    sortable: ""
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "countPeriodontalMap",
                    label: "Пародонтальная карта",
                    width: "210",
                    "header-align": "center",
                    align: "right",
                    sortable: ""
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "countTotal",
                    label: "Всего отчётов",
                    width: "150",
                    "header-align": "center",
                    align: "right",
                    sortable: ""
                  }),
                  (_unref(organizationId))
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 2,
                        prop: "timelyCount",
                        "header-align": "center",
                        align: "right",
                        label: "Своевременные повторные приёмы"
                      }))
                    : _createCommentVNode("", true),
                  (_unref(organizationId))
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 3,
                        prop: "yearlyTimelyCount",
                        "header-align": "center",
                        align: "right",
                        label: "Своевременные повторные приёмы за последний год"
                      }))
                    : _createCommentVNode("", true),
                  (!_unref(organizationId))
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 4,
                        prop: "timelyCount",
                        "header-align": "center",
                        align: "right",
                        label: "Своевременные повторные приёмы",
                        width: "180"
                      }))
                    : _createCommentVNode("", true),
                  (!_unref(organizationId))
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 5,
                        prop: "yearlyTimelyCount",
                        "header-align": "center",
                        align: "right",
                        label: "Своевременные повторные приёмы за последний год",
                        width: "240"
                      }))
                    : _createCommentVNode("", true),
                  (!_unref(organizationId))
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 6,
                        prop: "tariffLimit",
                        "header-align": "center",
                        align: "right",
                        label: "Тариф"
                      }))
                    : _createCommentVNode("", true),
                  (!_unref(organizationId))
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 7,
                        prop: "tariffUsage",
                        "header-align": "center",
                        align: "right",
                        label: "Расход",
                        width: "80"
                      }))
                    : _createCommentVNode("", true),
                  (!_unref(organizationId))
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 8,
                        prop: "tariffRemaining",
                        "header-align": "center",
                        align: "right",
                        label: "Перерасход",
                        width: "120"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class", "data"])), [
            [_directive_loading, loading.value]
          ]),
          (_unref(organizationId))
            ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                key: 0,
                class: "table",
                "row-class-name": "white-row-bold",
                "cell-class-name": "white-cell",
                "max-height": "200",
                "show-header": false,
                data: [summary.value]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "Имя",
                    width: "300"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "countPlaqueIndex",
                    label: "Индекс Налёта",
                    width: "155",
                    align: "right"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "countBrushMap",
                    label: "Карта ёршиков",
                    width: "155",
                    align: "right"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "countScreening",
                    label: "Скрининг",
                    width: "120",
                    align: "right"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "countPeriodontalMap",
                    label: "Пародонтальная карта",
                    width: "210",
                    align: "right"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "countTotal",
                    label: "Всего отчётов",
                    width: "150",
                    align: "right"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "timelyCount",
                    label: "Своевременные повторные приёмы",
                    align: "right"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "yearlyTimelyCount",
                    label: "Своевременные повторные приёмы за последний год",
                    align: "right"
                  })
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_loading, loading.value]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["locale"]),
      _createVNode(_component_el_pagination, {
        "current-page": currentPage.value,
        "page-size": countOnPage.value,
        total: totalCountOfElements.value,
        background: "",
        class: "statistic-table__pagination-item",
        layout: "prev, pager, next",
        onCurrentChange: handleChangeCurrentPage
      }, null, 8, ["current-page", "page-size", "total"])
    ])
  ]))
}
}

})